import { useEffect, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { readOccurrenceAttachments } from './contract';

/** Anexos da ocorrência, lidos só quando o card abre (a URL assinada vale 1 h). */
export default function useOccurrenceAttachments(occurrenceId, enabled) {
  const [state, setState] = useState({ key: null, loading: false, data: null, error: null });
  const key = enabled ? String(occurrenceId) : null;
  useEffect(() => {
    if (!key) return undefined;
    const abort = new AbortController();
    setState({ key, loading: true, data: null, error: null });
    cooperplaceApi
      .get(`occurrence-media/${key}`, { signal: abort.signal })
      .then(({ data }) => readOccurrenceAttachments(data))
      .then((data) => !abort.signal.aborted && setState({ key, loading: false, data, error: null }))
      .catch((error) => {
        if (abort.signal.aborted) return;
        setState({
          key,
          loading: false,
          data: null,
          error:
            error.response || error.isAxiosError
              ? 'Não foi possível carregar os anexos.'
              : error.message,
        });
      });
    return () => abort.abort();
  }, [key]);
  return state.key === key ? state : { loading: !!key, data: null, error: null };
}
